import React from 'react'

import Logo from './logo-aranalfe.png'
import FB from './ico-fb.png'
import IG from './ico-ig.png'
import WA from './ico-wa.png'
import { RealEstateDataPageComponentData } from 'types'
const Firma = ({ signature, offices }: RealEstateDataPageComponentData) => {
  const {
    name,
    email,
    address,
    position,
    image,
    cellphone,
    site,
    phone,
    wa,
    ig,
    fb,
    state,
    image_fb_icon,
    image_wa_icon,
    image_ig_icon,
  } = signature!

  return (
    <table
      className="firma-1"
      style={{ fontSize: '12px', fontFamily: 'Arial', lineHeight: '17px' }}
      width="520"
      border={0}
    >
      <tr>
        <td
          style={{
            width: '200px',
            fontSize: '12px',
            fontFamily: 'Arial',
            backgroundColor: '#ffffff',
            padding: '10px 10px 10px 10px',
            textAlign: 'center',
            verticalAlign: 'middle',
            borderWidth: 'medium',
            border: '2px',
            borderRight: '1px solid #000',
          }}
          valign="top"
        >
          <a
            href="https://aranalfe.com/"
            target="_blank"
          >
            {image && (
              <img
                width="171"
                height="auto"
                style={{ width: '180px', height: 'auto', border: '0' }}
                alt=""
                src={image}
              />
            )}
          </a>
        </td>

        <td
          style={{
            width: '400px',
            fontSize: '12px',
            fontFamily: 'Arial',
            padding: '5px 40px 15px 20px',
            backgroundColor: '#ffffff',
            verticalAlign: 'top',
          }}
          valign="top"
        >
          {name && (
            <span style={{ fontSize: '14px', fontFamily: 'Arial', color: '#000000;' }}>
              <strong>{name}</strong>
              <br />
            </span>
          )}
          {position && (
            <span style={{ fontSize: '14px', fontFamily: 'Arial', color: '#000000;' }}>
              {position}
              <br />
            </span>
          )}
          {offices?.map(({ address, phone, name }) => (
            <>
              {name && (
                <span style={{ fontSize: '12px', fontFamily: 'Arial', color: '#000000' }}>
                  <strong> {name} </strong>
                  <br />
                </span>
              )}
              {address && (
                <span style={{ fontSize: '12px', fontFamily: 'Arial', color: '#000000' }}>
                  {address}
                  <br />
                </span>
              )}
              {phone && (
                <span style={{ fontSize: '12px', fontFamily: 'Arial', color: '#000000' }}>
                  T. {phone}
                  <br />
                </span>
              )}
            </>
          ))}
          {cellphone && (
            <span style={{ fontSize: '12px', fontFamily: 'Arial', color: '#000000' }}>
              C. {cellphone}
              <br />
            </span>
          )}
          {phone && (
            <span style={{ fontSize: '12px', fontFamily: 'Arial', color: '#000000' }}>
              T. {phone}
              <br />
            </span>
          )}
          <span
            style={{
              fontSize: '12px',
              fontFamily: 'Arial',
              display: 'block',
            }}
          >
            <a
              href={'mailto:' + email}
              target="_blank"
              style={{
                textDecoration: 'none',
                marginTop: '2px',
                color: '#000000',
                fontSize: '12px',
                fontFamily: 'Arial',
              }}
            >
              {email}
            </a>
          </span>
          {address && (
            <span style={{ fontSize: '12px', fontFamily: 'Arial', color: '#000000' }}>
              {address}
              <br />
            </span>
          )}
          <span>
            <a
              href={wa}
              target="_blank"
            >
              <img
                alt="Whatsapp"
                style={{
                  border: '0',
                  height: '36px',
                  width: '36px',
                  marginTop: '5px',
                  marginRight: '5px',
                }}
                src={image_wa_icon || WA}
              />
            </a>
          </span>
          <span>
            <a
              href={fb}
              target="_blank"
            >
              <img
                alt="Facebook"
                style={{
                  border: '0',
                  height: '36px',
                  marginTop: '5px',
                  width: '36px',
                  marginRight: '5px',
                }}
                src={image_fb_icon || FB}
              />
            </a>
          </span>
          <span>
            <a
              href={ig}
              target="_blank"
            >
              <img
                alt="Instagram"
                style={{
                  marginTop: '5px',
                  border: '0',
                  height: '36px',
                  width: '36px',
                  marginRight: '10px',
                }}
                src={image_ig_icon || IG}
              />
            </a>
          </span>
        </td>
      </tr>

      <tr>
        <td
          style={{
            width: '200px',
            textAlign: 'left',
            backgroundColor: '#F3F2F0',
            padding: '20px 0px 20px 20px',
            verticalAlign: 'top',
          }}
          valign="top"
        >
          <span
            style={{ fontSize: '12px', lineHeight: '13px', fontFamily: 'Arial', color: '#000' }}
          >
            {state}
          </span>
        </td>

        <td
          width="600"
          align="center"
          style={{
            width: '400px',
            fontFamily: 'Arial',
            backgroundColor: '#000',
            fontSize: '15px',
            fontWeight: 'bold',
            color: '#fff',
            verticalAlign: 'middle',
          }}
        >
          <a
            href={'https://' + site}
            target="_blank"
            style={{ textDecoration: 'none', color: '#fff', fontFamily: 'Arial' }}
          >
            {site}
          </a>
        </td>
      </tr>
    </table>
  )
}

export default Firma
